<template>
  <div>
     <section class="header-wrapper mt-2">
        <div class="header-sec">
            <div class="header-nav">
                <div class="back-arrow">
                    <a class="chevronLeft-btn" @click="$router.go(-1)"><i class="fa fa-chevron-left"></i></a>
                </div>
                <div class="header-logo">
                    <div class="list-con header-sub-con">
                        <h4>{{pageTitle}}</h4>
                    </div>
                </div>
            </div>
            <div class="wallet-header-but" v-if="$route.name=='wallet-deposit' || $route.name=='deposit-payment-method'">
                <router-link :to="{ name : 'withdraw'}" class="thm-but">Want to Withdraw ?</router-link>
            </div>
            <div class="wallet-header-but" v-if="$route.name=='wallet-withdraw'">
                <router-link :to="{ name : 'wallet-deposit'}" class="thm-but">Want to Deposit ?</router-link>
            </div>
        </div>
    </section>
  </div>
</template>

<script>
export default {
name:'WalletHeader',
    data(){
        return{
            pageTitle:null,
            userData:null,
        }
    },
    mounted(){
        this.pageTitle=this.$route?.meta?.title
        this.userData=this.$store?.getters?.stateUser;
    }
}
</script>

<style>

</style>